<template>
  <qc-container title="意见反馈" >
    <page-request ref="table" url="/api/mgr/business/message/list" :table-header="tableHeader" :expend="expend" :op-width="200">
      <t-button  @click="batchHandle()">批量处理</t-button>
      <t-button @click="batchDel">批量删除</t-button>
      <template #op="scope">
        <b-button @click="doDetail(scope.row)">查看</b-button>
        <b-button v-if="scope.row.status===0" @click="doHandle([scope.row.id])">处理</b-button>
        <b-button  @click="doDel([scope.row.id])">删除</b-button>
      </template>
    </page-request>
  </qc-container>

  <feedback-detail ref="add" @close="pageReloadData()"></feedback-detail>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container";
import PageRequest from "/src/components/base/page-request";
import TButton from "/src/components/el/t-button";
import BButton from "/src/components/el/b-button";
import FeedbackDetail from "@view/content/op/feedback-detail.vue";


export default {
  name: 'feedback',
  components: {FeedbackDetail,  QcContainer, PageRequest,TButton,BButton},
  data () {
    return {
      tableHeader: [
        {type:"selection",label:""},
        {type:"user",label:"反馈用户",width:220},
        {type:"feedback",label:"反馈内容",minWidth:260},
        {label: "状态",width: 100,renderDraw:(row)=>{
          return row.status?"已处理":"待处理";
          }},
        {prop: "handleTime", label: "处理时间",width:160},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend:[
        {prop: "nickname", label: "反馈用户"},
        {prop: "userCode", label: "用户编号"},
        {label: "状态", prop: "status",type:"select",options:[{"label":"待处理","value":"0"},{"label":"已处理","value":"1"}]},
        {label: "处理时间", start: "handleTimeStart", end: "handleTimeEnd", type: "daterange"},
        {label: "创建时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    doDetail(row){
      this.$refs.add.open(row);
    },
    doDel(ids){
      this.msgConfirm("/api/mgr/business/message/delete",{ids:ids},()=>{
        this.pageReloadData();
      });
    },
    batchDel(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.doDel(ids);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    batchHandle(){
      let list = this.$refs.table.getSelectionRows();
      list = list.filter(item=>item.status===0);
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.doHandle(ids);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    doHandle(ids){
      this.msgConfirm("/api/mgr/business/message/batchHandle",{ids:ids},()=>{
        this.pageReloadData();
      },"是否将选中项标记为已处理");
    }
  },
  mounted () {

  }
}
</script>


<style lang="less" scoped>

</style>
